/**
 * @module ArticleCard
 */

import Component from '../base/Component';
import './styles.css';
import '../../scripts/picture';
import '../../images/sprite/play.svg';

/**
 * Раздел UI Kit.
 */
export default class ArticleCard extends Component {
    static className = 'article-card';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}
